import { environment } from '@environments/environment';
import { ElasticSearchQueryInput, StoreQuery } from '@services/elastic-search/models';

export const GET_STORES_QUERY = (query: StoreQuery = {}): ElasticSearchQueryInput => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    size: 1000,
    query: {
      bool: {
        filter: [
          { term: { search_api_datasource: 'entity:node' } },
          { term: { status: true } },
          ...getLocationFilters(query),
          ...(query.decoConsultingEnabled ? [{ term: { deco_consulting_enabled: true } }] : []),
        ],
      },
    },
    sort: [
      {
        title: {
          order: 'asc',
        },
      },
    ],
  },
});

const getLocationFilters = (query: {
  countryCode?: string;
  codeRegion?: string;
}): {
  term: Record<string, string>;
}[] => {
  const filters: { term: Record<string, string> }[] = [];
  if (query.countryCode && !query.codeRegion) filters.push({ term: { field_code_pays: query.countryCode } });
  if (query.codeRegion) filters.push({ term: { region_code: query.codeRegion } });
  return filters;
};
